import { _sharedActionsConstantsSettings } from "./actions";

export const _sharedStateSettings = {
  geoIpData: {},
};

export const _sharedReducerSettings = (state, action) => {
  switch (action.type) {
    case _sharedActionsConstantsSettings.UPDATE_SETTING_SUCCESS: {
      return { ...state, ...action.data };
    }
    case _sharedActionsConstantsSettings.FETCH_GEO_IP_DATA_SUCCESS: {
      return { ...state, geoIpData: action.data };
    }
    default:
      return state;
  }
};
